// import classes from "./WelcomeMessage.module.css";
// import apple from "./../../../assets/images/apple.png";
// import android from "./../../../assets/images/android.png";
// import information from "./../../../assets/images/information_project.png";
// import { useTranslation } from "react-i18next";
// import {
//   androidAppLink,
//   informationLink,
//   informationLinkEN,
//   iosAppLink,
//   welcomeMessageContent,
// } from "../../../../SMARTCITY/hardCodeData/DATA";
// import { useContext } from "react";
// import LanguageContext from "../../../hooks/language-context";
// import { useHistory } from "react-router-dom";
// import SvgTermsofuse2 from "../../../assets/icons/Termsofuse2";

// import sponsor from "./../../../../SMARTCITY/assets/images/sponsor.png";
// import mosaic from "./../../../../SMARTCITY/assets/images/mosaic_banner.png";

// const WelcomeMessage = () => {
//   const { t } = useTranslation();
//   const languageCtx = useContext(LanguageContext);
//   const history = useHistory();
//   return (
//     <div
//       style={{
//         width: "314px",
//         marginLeft: "4px",
//         display: "flex",
//         flexDirection: "column",
//         gap: "10px",
//         alignItems: "center",
//         paddingTop: "30px",
//         justifyContent: "flex-start",
//       }}
//     >
//       <div
//         style={{
//           width: "300px",
//           display: "flex",
//           flexDirection: "column",
//           gap: "10px",
//           lineHeight: "1.2",
//           fontWeight: "700",
//           color: "white",
//         }}
//       >
//         <p>{t(welcomeMessageContent[0])}</p>
//         <p>{t(welcomeMessageContent[1])}</p>
//       </div>

//       <a
//         href="https://www.the-hellenic-mosaic.gr/"
//         target="_blank"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           margin: "0 auto",
//           marginBottom: "10px",
//         }}
//       >
//         <img src={mosaic} alt="mosaic logo" className={classes.mosaic_normal} />
//       </a>

//       <div
//         style={{
//           marginTop: "auto",
//         }}
//       >
//         <div
//           style={{
//             width: "302px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             // height: "fit-content",
//             // padding: "4px 14px",
//             backgroundColor: "#fff",
//             margin: "0 auto",
//             marginBottom: "6px",
//             // display: "flex",
//             // alignItems: "center",
//             // justifyContent: "center",
//           }}
//         >
//           <img
//             src={sponsor}
//             alt="sponsor logo"
//             style={{ width: "260px", height: "auto" }}
//           />
//         </div>
//         <div
//           style={{
//             width: "260px",
//             height: "40px",
//             display: "flex",
//             alignItems: "center",
//             gap: "10px",
//             fontSize: "16px",
//             fontWeight: "600",
//             color: "#fff",
//             backgroundColor: "#000",
//             padding: "4px 22px",
//             borderRadius: "6px",
//             border: "2px solid #5f5f5f",
//             margin: "0 auto",
//           }}
//           onClick={() =>
//             window.open(
//               languageCtx.languageCode === "en"
//                 ? informationLinkEN
//                 : informationLink
//             )
//           }
//         >
//           <img
//             src={information}
//             alt={"information-application"}
//             width={35}
//             style={{ backgroundColor: "#fff", borderRadius: "50%" }}
//           />
//           <p>{t("Πληροφορίες για το έργο")}</p>
//         </div>
//         {(iosAppLink || androidAppLink) && (
//           <div className={classes.appsPlaceholder}>
//             {iosAppLink && (
//               <img
//                 src={apple}
//                 alt={"apple-application"}
//                 width={150}
//                 onClick={() => window.open(iosAppLink)}
//               />
//             )}
//             {androidAppLink && (
//               <img
//                 src={android}
//                 alt={"android-application"}
//                 width={150}
//                 onClick={() => window.open(androidAppLink)}
//               />
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default WelcomeMessage;

// // <div className={classes.welcome_placeholder}>
// //   <p>{t(welcomeMessageContent[0])}</p>
// //   <p>{t(welcomeMessageContent[1])}</p>

// //   <div>
// //     {/* <div
// //       style={{ marginBottom: 5 }}
// //       onClick={() => history.push("/terms-of-use")}
// //     >
// //       <SvgTermsofuse2 width={35} />
// //       {languageCtx.languageCode === "el" ? (
// //         <p>{t("Όροι Χρήσης")}</p>
// //       ) : (
// //         <p>{t("Terms of Use")}</p>
// //       )}
// //     </div> */}
// //     {/* <div
// //       style={{ marginBottom: 5 }}
// //       onClick={() => history.push("/accessibility")}
// //     >
// //       <SvgTermsofuse2 width={35} />
// //       {languageCtx.languageCode === "el" ? (
// //         <p>{t("Δήλωση προσβασιμότητας")}</p>
// //       ) : (
// //         <p>{t("Terms of Use")}</p>
// //       )}
// //     </div> */}
// //     <div
// //       onClick={() =>
// //         window.open(
// //           languageCtx.languageCode === "en"
// //             ? informationLinkEN
// //             : informationLink
// //         )
// //       }
// //     >
// //       <img src={information} alt={"information-application"} width={35} />
// //       <p>{t("Πληροφορίες για το έργο")}</p>
// //     </div>
// //     <div>
// //       <img
// //         src={apple}
// //         alt={"apple-application"}
// //         width={150}
// //         onClick={() => window.open(iosAppLink)}
// //       />
// //       <img
// //         src={android}
// //         alt={"android-application"}
// //         width={150}
// //         onClick={() => window.open(androidAppLink)}
// //       />
// //     </div>
// //   </div>
// // </div>

import classes from "./WelcomeMessage.module.css";
import apple from "./../../../assets/images/apple.png";
import android from "./../../../assets/images/android.png";
import information from "./../../../assets/images/information_project.png";
import { useTranslation } from "react-i18next";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
  welcomeMessageContent,
} from "../../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../../hooks/language-context";
import sponsor from "./../../../../SMARTCITY/assets/images/sponsor.png";
import mosaic from "./../../../../SMARTCITY/assets/images/mosaic_banner.png";

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);
  return (
    <div
      style={{
        width: "314px",
        marginLeft: "4px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        paddingTop: "30px",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          width: "300px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          lineHeight: "1.2",
          fontWeight: "700",
          color: "white",
        }}
      >
        <p>{t(welcomeMessageContent[0])}</p>
        <p>{t(welcomeMessageContent[1])}</p>
      </div>

      <a
        href="https://www.the-hellenic-mosaic.gr/"
        target="_blank"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
          marginBottom: "10px",
        }}
      >
        <img src={mosaic} alt="mosaic logo" className={classes.mosaic_normal} />
      </a>

      <div
        style={{
          marginTop: "auto",
        }}
      >
        <div
          style={{
            width: "302px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // height: "fit-content",
            // padding: "4px 14px",
            backgroundColor: "#fff",
            margin: "0 auto",
            marginBottom: "6px",
            // display: "flex",
            // alignItems: "center",
            // justifyContent: "center",
          }}
        >
          <img
            src={sponsor}
            alt="sponsor logo"
            style={{ width: "260px", height: "auto" }}
          />
        </div>
        <div
          style={{
            width: "260px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#fff",
            backgroundColor: "#000",
            padding: "4px 22px",
            borderRadius: "6px",
            border: "2px solid #5f5f5f",
            margin: "0 auto",
            cursor: "pointer",
          }}
          onClick={() =>
            window.open(
              languageCtx.languageCode === "en"
                ? informationLinkEN
                : informationLink
            )
          }
        >
          <img
            src={information}
            alt={"information-application"}
            width={35}
            style={{ backgroundColor: "#fff", borderRadius: "50%" }}
          />
          <p>{t("Πληροφορίες για το έργο")}</p>
        </div>
        {(iosAppLink || androidAppLink) && (
          <div className={classes.appsPlaceholder}>
            {iosAppLink && (
              <img
                src={apple}
                alt={"apple-application"}
                width={150}
                onClick={() => window.open(iosAppLink)}
              />
            )}
            {androidAppLink && (
              <img
                src={android}
                alt={"android-application"}
                width={150}
                onClick={() => window.open(androidAppLink)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeMessage;
